import React from 'react';
import { useSpecSheetField } from '../../../../../queries/useSpecSheetField';
import { TextBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';

interface QualityAssuranceProps {
    readOnly?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const QualityAssurance: React.FC<QualityAssuranceProps> = ({ readOnly = false, propertyGuid, isReview = false }) => {
    const [qualityAssurance, setQualityAssurance] = useSpecSheetField(
        propertyGuid,
        (s) => s.values?.['Additional Features']?.['Quality Assurance'] ?? '',
        (s, v) => ({ ...s, values: { ...s.values, 'Additional Features': { ...s.values?.['Additional Features'], 'Quality Assurance': v } } })
    );
    const label = 'Quality Assurance';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={qualityAssurance}
                />
            ) : (
                <TextBox
                    value={qualityAssurance ?? ''}
                    onChange={(value) => setQualityAssurance(value)}
                    label={label}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
